import { render } from "./DisciPle.vue?vue&type=template&id=1c37ea98&scoped=true&ts=true"
import script from "./DisciPle.vue?vue&type=script&lang=ts"
export * from "./DisciPle.vue?vue&type=script&lang=ts"

import "./DisciPle.vue?vue&type=style&index=0&id=1c37ea98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c37ea98"]])

export default __exports__